import {apiClient} from "../../../../lib/api-client";
import {ApiResult} from "../../../../types/ApiResult";
import {KindOfOrder} from "../../../../types/enums";
import {OrderNote} from "../types/OrderNote";

export async function apiAddOrderNote(orderID: number, kindOfOrder: KindOfOrder, note: OrderNote): Promise<ApiResult> {
    try {
        return await apiClient.post("note/add", {
            orderID: orderID,
            kindOfOrder: kindOfOrder,
            noteText: note.noteText,
            internalPortal: note.internalPortal,
            noteType: note.noteType
        });
    }
    catch (error) {
        return {
            isSuccess: false,
            errorMessage: "Error when adding the note: " + error
        };
    }
}
